const SharedCard = ({ children }: any) => {
  return <div className='bg-white w-full rounded-md shadow-md overflow-x-auto'>{children}</div>;
};

export default SharedCard;
